// SEO configuration for each page
const seoConfig = {
  landing: {
    title: 'LoraTag - AI-Powered Image Captioning for LoRA Training | Batch Dataset Preparation Tool',
    description: 'Caption hundreds of images for LoRA training in minutes. LoraTag automates dataset preparation with customizable detail levels, batch processing, and directory support. Try free.'
  },
  upload: {
    title: 'Upload & Caption Images | LoraTag - Batch AI Image Captioning',
    description: 'Upload and caption multiple images at once with LoraTag. Choose quality levels, add global tags, and generate training data for character, style, or object LoRAs.'
  },
  history: {
    title: 'Caption History & Sessions | LoraTag - Manage Your Datasets',
    description: 'View, download, and manage all your captioned image sessions. Export captions in multiple formats and track your LoRA dataset preparation progress.'
  },
  account: {
    title: 'My Account | LoraTag - Subscription & Usage Management',
    description: 'Manage your LoraTag account, view usage statistics, upgrade subscription plans, and access billing information for AI-powered image captioning.'
  },
  gettingStarted: {
    title: 'Getting Started Guide | LoraTag - How to Caption Images for LoRA',
    description: 'Learn how to use LoraTag for LoRA dataset preparation. Step-by-step guide covering image upload, quality settings, and best practices for training data.'
  },
  privacy: {
    title: 'Privacy Policy | LoraTag - Data Protection & Security',
    description: 'LoraTag privacy policy detailing how we protect your images and data. Learn about our security measures, data handling, and user privacy rights.'
  },
  terms: {
    title: 'Terms of Service | LoraTag - Usage Terms & Conditions',
    description: 'Terms and conditions for using LoraTag AI image captioning service. Understand your rights, usage limits, and service agreements.'
  },
  cookies: {
    title: 'Cookie Policy | LoraTag - Cookie Usage & Preferences',
    description: 'Learn how LoraTag uses cookies to improve your experience. Manage cookie preferences and understand our data collection practices.'
  },
  forgotPassword: {
    title: 'Reset Password | LoraTag - Account Recovery',
    description: 'Reset your LoraTag account password. Secure password recovery for continued access to AI-powered image captioning services.'
  },
  notFound: {
    title: 'Page Not Found | LoraTag - 404 Error',
    description: 'The page you are looking for does not exist. Return to LoraTag to continue captioning images for your LoRA training datasets.'
  },
  loraTraining: {
    title: 'Image Captioning for LoRA Training: The Complete Guide | LoraTag',
    description: 'Learn how to properly caption images for LoRA training. Step-by-step guide to creating perfect training datasets for AI model fine-tuning with LoraTag.'
  }
};

export default seoConfig;